<template>
    <div class="footer_wrapper">
        <div class="footer row" ref="footer">
            <div id="footer_item">
                <a class="a_tag" id="commerce_law" @click="redirectToCommerceLawPage">特定商取引法に基づく表記</a>
                <span style="margin-left: 5px; margin-right: 5px">|</span>
                <a class="a_tag" href="https://chura-venture.com/">ちゅらベンチャー</a>
            </div>
        </div>
    </div>
</template>

<script>
    import Pages from "../../router/Pages";
    export default {
        name: "Footer",

        methods: {
            redirectToCommerceLawPage() {
                this.$router.push({path: Pages.commerceLawRules.path});
            }

        }
    }
</script>

<style scoped lang="scss">
    .footer {
        height: 50px;
        background-color: #4B86E8;
        color: #ffffff;
        /*position: fixed;*/
        /*bottom: 0;*/
        width: 100%;
        margin-top: 20px;

        #commerce_law:hover {
            cursor: pointer;
            text-decoration: underline;
        }

        .a_tag {
            color: #ffffff;
            text-decoration: none;
        }

        .a_tag:hover {
            cursor: pointer;
            text-decoration: underline;
        }

        #footer_item {
            padding-top: 15px;
            padding-left: 70px
        }

        @media only screen and (max-width: 450px){
            #footer_item {
                padding-top: 15px;
                padding-left: 10px;
            }
        }

        @media only screen and (max-width: 320px){
            #footer_item {
                font-size: 15px;
                padding-left: 0;
            }
        }
    }
</style>